import { useEffect } from "react";

/**
 * Hook to fetch position data for a specific site
 * @param {number} siteIndex - Index of the site
 * @param {number} height - Height value
 * @param {function} setPositions - Function to set positions
 * @param {object} cachedData - Cached data object
 */
function useFetchPositions(siteIndex, height, setPositions, cachedData) {
    useEffect(() => {
        // Only set positions if we have valid cached data
        if (cachedData && 
            cachedData[siteIndex] &&
            cachedData[siteIndex].positions) {
            console.log(`Using cached positions for site ${siteIndex}`);
            setPositions(cachedData[siteIndex].positions);
        }
    }, [siteIndex, height, cachedData, setPositions]);
}

export default useFetchPositions;